// Shared widget style tokens & builders for consistent preview/runtime rendering

export const WIDGET_HEADER_HEIGHT = 44;

/**
 * Returns the default card surface color for the given theme mode.
 * light -> #FFFFFF  |  dark -> #1E1E1E
 */
export const getThemeSurface = (themeMode) =>
  themeMode === 'dark' ? '#1E1E1E' : '#FFFFFF';

/**
 * Resolves the effective widget card background color.
 *
 * Priority:
 *   1. hasCustomBackground === true AND color is non-empty  → use saved custom color in all themes
 *   2. Otherwise (new widget / old widget without flag / flag reset) → follow current theme surface
 *
 * @param {object} rawBasic  - widget.props.basic (or normalised basicProps)
 * @param {string} themeMode - 'light' | 'dark'
 * @returns {string} resolved hex color
 */
export const resolveWidgetBackground = (rawBasic, themeMode) => {
  const custom = (rawBasic?.color_background || rawBasic?.backgroundColor || '').trim();
  if (rawBasic?.hasCustomBackground === true && custom !== '') return custom;
  return getThemeSurface(themeMode);
};

export const iconBtnSx = {
  // bgcolor: 'rgba(255,255,255,0.85)',
  border: "0px",
  width: 30,
  height: 30,
  // '&:hover': { bgcolor: '#FFFFFF' },
  boxShadow: '0 1px 2px rgba(0,0,0,0.08)'
};

export const buildWidgetCardSx = (basicProps = {}, overrides = {}) => {
  const {
    backgroundColor = '#FFFFFF',
    borderRadius, // Apply border radius only if explicitly provided (non-null/defined). Fallback 0 otherwise.
    borderColor = '#D8DFE3',
    fontType = 'Roboto',
    borderSize = 1
  } = basicProps;
  return {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor,
    borderRadius: typeof borderRadius === 'number' && !isNaN(borderRadius) ? `${borderRadius}px` : '0px',
    border: `${borderSize}px solid ${borderColor}`,  
    fontFamily: fontType,
    '&:hover .wc-action-bar': { opacity: 1, pointerEvents: 'auto' },
    ...overrides
  };
};

export const widgetHeaderSx = (basicProps = {}) => ({
  height: WIDGET_HEADER_HEIGHT,
  display: 'flex',
  alignItems: 'center',
  pl: 1.5,
  gap: 1,
  padding: '0 8px',
  opacity: 0.97
});

export const widgetTitleSx = (basicProps = {}) => ({
  fontSize: `${basicProps.fontSize || 16}px`,
  lineHeight: 1.5,
  fontWeight: 700,
  color: basicProps.textColor || '#008CD7',
  letterSpacing: "0.00938em",
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  fontFamily: basicProps.fontType || 'Roboto',
  flexShrink: 0,
  maxWidth: '60%',
});

export const widgetContentSx = {
  flex: 1,
  p: 0.5,
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
  overflow: 'hidden'
};